import axios from 'axios';
import { LeadsWindowModel } from '../models/LeadsWindowModel';

const API_URL = process.env.REACT_APP_API_URL;

interface UpdateLeadsWindowBody {
  shift: LeadsWindowModel['shift'];
  from_date: string;
  to_date: string;
  sale_agent: number;
}

export async function updateLeadsWindow(
  id: number,
  body: UpdateLeadsWindowBody
): Promise<{ data: LeadsWindowModel }> {
  return axios.put(`${API_URL}/api/crm/leads-windows/${id}/`, body);
}
